//@config
export default {
  research: {
    base: "v1/research",
    researchers: "v1/researchers",
    researcher: "v1/researcher",
    research_help: "v1/help/research_help",
    help: "v1/help",
    research_plan: "v1/research_plan",
    research_manager: "v1/research_manager",
    research_manager_researcher: "v1/research_manager/{0}/researcher/{1}",
    azmoon_execute_person_reference:
      "v1/azmoon_execute/{0}/person/{1}/operator/{2}/reference/{3}",
    research_relation: "v1/research_relation/{0}",
    inner_research: "v1/inner_research",
    researcher_me: "v1/researcher/{id}/me",
    research_person_combo: "v1/research_person?search_txt={1}",
    delete_research_manager_researcher: "v1/research_manager_researcher",
    all_research_manager_researcher: "v1/research_manager_researcher",
    ready_research: "v1/ready_research",
    research_manager_combo: "v2/research_manager?search_txt={0}",
    connect_research_manager_audience: "v1/research_manager_audience",
    research_queue: "v1/research_queue",
    research_queue_id: "v1/research_queue/{0}",
    assign_me_researcher: "v1/research_queue/{0}/assign_me_researcher",
    researcher_combo: "v1/researcher?search_txt={0}",
    assign_researcher: "v1/assign_researcher",
    term_state_combo: "v1/term_state_combo",
    research_plan_detail: "v1/research_queue/{0}",
    research_queue_plan: "v1/research_queue/{0}/plan",
    research_queue_plan_detail: "v1/research_queue/{0}/plan/{1}",
    research_queue_research_manager_azmoon: "v1/research_queue/{0}/research_manager_azmoon",
  }
};
